export default "__VITE_ASSET__C7S_9Uo5__"